import * as React from 'react';
import style from './Home.css';

import {
  Main,
  Medium,
  Integrate,
  History,
  Wath,
  DigitalTwin,
  Trusted
} from './Sections';

let WOW = function() {};
if (typeof window !== 'undefined') {
  WOW = require('wowjs');
}

export class Home extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      let wow = new WOW({
        mobile: false,
        live: true,
        scrollContainer: null,
        offset: 250
      });
      wow.init();
    }
  }

  handleScrollDown = () => {
    this.blockWath.scrollIntoView({
      behavior: 'smooth'
    });
  };

  render() {
    return (
      <article property="mainEntity" className={style.root}>
                <Main onScrollDown={this.handleScrollDown}/>
                {/*<Wath _ref={c => this.blockWath = c}/>*/}
                <Integrate/>
                <DigitalTwin/>
                <History/>
                <Trusted/>
            </article>
    )
  }
}
